'use client';

import React, { useState } from 'react';

import { BrandLockup } from '@/components/common/BrandLockup';
import { PARTNER_LABELS, PARTNER_LOGOS, type Partner } from '@/config/partnerLogos';
import { cn } from '@/lib/utils';

function PartnerLogoImage({ partner }: { partner: Partner }) {
  const [failed, setFailed] = useState(false);
  const logo = PARTNER_LOGOS[partner];
  const label = PARTNER_LABELS[partner];

  if (failed) {
    return <span className="text-xs font-medium text-[var(--muted-foreground)]">{label}</span>;
  }

  return (
    // eslint-disable-next-line @next/next/no-img-element
    <img
      src={logo.src}
      alt={label}
      className={cn(
        'object-contain object-left',
        logo.kind === 'mark' ? 'h-5 w-5' : 'h-4 w-auto max-w-[7rem]'
      )}
      onError={() => setFailed(true)}
    />
  );
}

/** A small row of partner logos in full color. */
export function PartnerLogoRow({
  partners,
  className,
}: {
  partners: Partner[];
  className?: string;
}) {
  if (partners.length === 0) return null;
  return (
    <span className={cn('flex flex-wrap items-center gap-x-4 gap-y-2', className)}>
      {partners.map((p) => (
        <PartnerLogoImage key={p} partner={p} />
      ))}
    </span>
  );
}

/** Partner lockup for a section heading (mark + name, or wordmark alone). */
export function PartnerLockup({ partner, size }: { partner: Partner; size?: 'md' | 'lg' }) {
  return <BrandLockup label={PARTNER_LABELS[partner]} logo={PARTNER_LOGOS[partner]} size={size} />;
}
